import compose from 'recompose/compose';
import setDisplayName from 'recompose/setDisplayName';
import withProps from 'recompose/withProps';

export default compose(
	setDisplayName('withNavigateToList'),
	withProps(props => ({
		navigateToList() {
			props.history.push('/admin');
		}
	}))
);



// WEBPACK FOOTER //
// ./src/client/components/admin/collections/with-navigate-to-list.js